var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnownight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1360,
    height: 80,
    viewBox: "0 0 1360 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1360,
    height: 80,
    rx: 12,
    fill: "#286897"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_568_226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1360,
    height: 80
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1360,
    height: 80,
    rx: 12,
    fill: "#286897"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_568_226)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1250.25 40C1250.25 39.4477 1249.8 39 1249.25 39C1248.7 39 1248.25 39.4477 1248.25 40V43.8358L1245.54 41.1235C1245.15 40.7329 1244.51 40.7329 1244.12 41.1235C1243.73 41.514 1243.73 42.1471 1244.12 42.5377L1246.84 45.25H1243C1242.45 45.25 1242 45.6977 1242 46.25C1242 46.8023 1242.45 47.25 1243 47.25H1246.84L1244.12 49.9623C1243.73 50.3529 1243.73 50.986 1244.12 51.3765C1244.51 51.7671 1245.15 51.7671 1245.54 51.3765L1248.25 48.6642V52.5C1248.25 53.0523 1248.7 53.5 1249.25 53.5C1249.8 53.5 1250.25 53.0523 1250.25 52.5V48.6642L1252.96 51.3765C1253.35 51.767 1253.99 51.767 1254.38 51.3765C1254.77 50.986 1254.77 50.3528 1254.38 49.9623L1251.66 47.25H1255.5C1256.05 47.25 1256.5 46.8023 1256.5 46.25C1256.5 45.6977 1256.05 45.25 1255.5 45.25H1251.66L1254.38 42.5377C1254.77 42.1472 1254.77 41.514 1254.38 41.1235C1253.99 40.733 1253.35 40.733 1252.96 41.1235L1250.25 43.8358V40Z",
    fill: "url(#paint0_linear_568_226)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1234.25 64C1234.25 63.4477 1233.8 63 1233.25 63C1232.7 63 1232.25 63.4477 1232.25 64V67.8358L1229.54 65.1235C1229.15 64.7329 1228.51 64.7329 1228.12 65.1235C1227.73 65.514 1227.73 66.1471 1228.12 66.5377L1230.84 69.25H1227C1226.45 69.25 1226 69.6977 1226 70.25C1226 70.8023 1226.45 71.25 1227 71.25H1230.84L1228.12 73.9623C1227.73 74.3529 1227.73 74.986 1228.12 75.3765C1228.51 75.7671 1229.15 75.7671 1229.54 75.3765L1232.25 72.6642V76.5C1232.25 77.0523 1232.7 77.5 1233.25 77.5C1233.8 77.5 1234.25 77.0523 1234.25 76.5V72.6642L1236.96 75.3765C1237.35 75.767 1237.99 75.767 1238.38 75.3765C1238.77 74.986 1238.77 74.3528 1238.38 73.9623L1235.66 71.25H1239.5C1240.05 71.25 1240.5 70.8023 1240.5 70.25C1240.5 69.6977 1240.05 69.25 1239.5 69.25H1235.66L1238.38 66.5377C1238.77 66.1472 1238.77 65.514 1238.38 65.1235C1237.99 64.733 1237.35 64.733 1236.96 65.1235L1234.25 67.8358V64Z",
    fill: "url(#paint1_linear_568_226)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1264.25 67C1264.25 66.4477 1263.8 66 1263.25 66C1262.7 66 1262.25 66.4477 1262.25 67V70.8358L1259.54 68.1235C1259.15 67.7329 1258.51 67.7329 1258.12 68.1235C1257.73 68.514 1257.73 69.1471 1258.12 69.5377L1260.84 72.25H1257C1256.45 72.25 1256 72.6977 1256 73.25C1256 73.8023 1256.45 74.25 1257 74.25H1260.84L1258.12 76.9623C1257.73 77.3529 1257.73 77.986 1258.12 78.3765C1258.51 78.7671 1259.15 78.7671 1259.54 78.3765L1262.25 75.6642V79.5C1262.25 80.0523 1262.7 80.5 1263.25 80.5C1263.8 80.5 1264.25 80.0523 1264.25 79.5V75.6642L1266.96 78.3765C1267.35 78.767 1267.99 78.767 1268.38 78.3765C1268.77 77.986 1268.77 77.3528 1268.38 76.9623L1265.66 74.25H1269.5C1270.05 74.25 1270.5 73.8023 1270.5 73.25C1270.5 72.6977 1270.05 72.25 1269.5 72.25H1265.66L1268.38 69.5377C1268.77 69.1472 1268.77 68.514 1268.38 68.1235C1267.99 67.733 1267.35 67.733 1266.96 68.1235L1264.25 70.8358V67Z",
    fill: "url(#paint2_linear_568_226)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1282.25 49C1282.25 48.4477 1281.8 48 1281.25 48C1280.7 48 1280.25 48.4477 1280.25 49V52.8358L1277.54 50.1235C1277.15 49.7329 1276.51 49.7329 1276.12 50.1235C1275.73 50.514 1275.73 51.1471 1276.12 51.5377L1278.84 54.25H1275C1274.45 54.25 1274 54.6977 1274 55.25C1274 55.8023 1274.45 56.25 1275 56.25H1278.84L1276.12 58.9623C1275.73 59.3529 1275.73 59.986 1276.12 60.3765C1276.51 60.7671 1277.15 60.7671 1277.54 60.3765L1280.25 57.6642V61.5C1280.25 62.0523 1280.7 62.5 1281.25 62.5C1281.8 62.5 1282.25 62.0523 1282.25 61.5V57.6642L1284.96 60.3765C1285.35 60.767 1285.99 60.767 1286.38 60.3765C1286.77 59.986 1286.77 59.3528 1286.38 58.9623L1283.66 56.25H1287.5C1288.05 56.25 1288.5 55.8023 1288.5 55.25C1288.5 54.6977 1288.05 54.25 1287.5 54.25H1283.66L1286.38 51.5377C1286.77 51.1472 1286.77 50.514 1286.38 50.1235C1285.99 49.733 1285.35 49.733 1284.96 50.1235L1282.25 52.8358V49Z",
    fill: "url(#paint3_linear_568_226)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1316.25 40C1316.25 39.4477 1315.8 39 1315.25 39C1314.7 39 1314.25 39.4477 1314.25 40V43.8358L1311.54 41.1235C1311.15 40.7329 1310.51 40.7329 1310.12 41.1235C1309.73 41.514 1309.73 42.1471 1310.12 42.5377L1312.84 45.25H1309C1308.45 45.25 1308 45.6977 1308 46.25C1308 46.8023 1308.45 47.25 1309 47.25H1312.84L1310.12 49.9623C1309.73 50.3529 1309.73 50.986 1310.12 51.3765C1310.51 51.7671 1311.15 51.7671 1311.54 51.3765L1314.25 48.6642V52.5C1314.25 53.0523 1314.7 53.5 1315.25 53.5C1315.8 53.5 1316.25 53.0523 1316.25 52.5V48.6642L1318.96 51.3765C1319.35 51.767 1319.99 51.767 1320.38 51.3765C1320.77 50.986 1320.77 50.3528 1320.38 49.9623L1317.66 47.25H1321.5C1322.05 47.25 1322.5 46.8023 1322.5 46.25C1322.5 45.6977 1322.05 45.25 1321.5 45.25H1317.66L1320.38 42.5377C1320.77 42.1472 1320.77 41.514 1320.38 41.1235C1319.99 40.733 1319.35 40.733 1318.96 41.1235L1316.25 43.8358V40Z",
    fill: "url(#paint4_linear_568_226)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1311.25 64C1311.25 63.4477 1310.8 63 1310.25 63C1309.7 63 1309.25 63.4477 1309.25 64V67.8358L1306.54 65.1235C1306.15 64.7329 1305.51 64.7329 1305.12 65.1235C1304.73 65.514 1304.73 66.1471 1305.12 66.5377L1307.84 69.25H1304C1303.45 69.25 1303 69.6977 1303 70.25C1303 70.8023 1303.45 71.25 1304 71.25H1307.84L1305.12 73.9623C1304.73 74.3529 1304.73 74.986 1305.12 75.3765C1305.51 75.7671 1306.15 75.7671 1306.54 75.3765L1309.25 72.6642V76.5C1309.25 77.0523 1309.7 77.5 1310.25 77.5C1310.8 77.5 1311.25 77.0523 1311.25 76.5V72.6642L1313.96 75.3765C1314.35 75.767 1314.99 75.767 1315.38 75.3765C1315.77 74.986 1315.77 74.3528 1315.38 73.9623L1312.66 71.25H1316.5C1317.05 71.25 1317.5 70.8023 1317.5 70.25C1317.5 69.6977 1317.05 69.25 1316.5 69.25H1312.66L1315.38 66.5377C1315.77 66.1472 1315.77 65.514 1315.38 65.1235C1314.99 64.733 1314.35 64.733 1313.96 65.1235L1311.25 67.8358V64Z",
    fill: "url(#paint5_linear_568_226)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1343.25 52C1343.25 51.4477 1342.8 51 1342.25 51C1341.7 51 1341.25 51.4477 1341.25 52V55.8358L1338.54 53.1235C1338.15 52.7329 1337.51 52.7329 1337.12 53.1235C1336.73 53.514 1336.73 54.1471 1337.12 54.5377L1339.84 57.25H1336C1335.45 57.25 1335 57.6977 1335 58.25C1335 58.8023 1335.45 59.25 1336 59.25H1339.84L1337.12 61.9623C1336.73 62.3529 1336.73 62.986 1337.12 63.3765C1337.51 63.7671 1338.15 63.7671 1338.54 63.3765L1341.25 60.6642V64.5C1341.25 65.0523 1341.7 65.5 1342.25 65.5C1342.8 65.5 1343.25 65.0523 1343.25 64.5V60.6642L1345.96 63.3765C1346.35 63.767 1346.99 63.767 1347.38 63.3765C1347.77 62.986 1347.77 62.3528 1347.38 61.9623L1344.66 59.25H1348.5C1349.05 59.25 1349.5 58.8023 1349.5 58.25C1349.5 57.6977 1349.05 57.25 1348.5 57.25H1344.66L1347.38 54.5377C1347.77 54.1472 1347.77 53.514 1347.38 53.1235C1346.99 52.733 1346.35 52.733 1345.96 53.1235L1343.25 55.8358V52Z",
    fill: "url(#paint6_linear_568_226)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1238.22 -15.9894C1241.61 -39.7406 1262.04 -58 1286.73 -58C1302.81 -58 1317.09 -50.2481 1326.02 -38.2761C1329.88 -39.5136 1334 -40.1818 1338.27 -40.1818C1360.41 -40.1818 1378.36 -22.2325 1378.36 -0.0909119C1378.36 22.0507 1360.41 40 1338.27 40H1286.73H1239H1235.18V39.7418C1221.52 37.8796 1211 26.1688 1211 12C1211 -3.20379 1223.12 -15.5773 1238.22 -15.9894Z",
    fill: "#1F4F72"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_568_226",
    x1: 1249.25,
    y1: 34,
    x2: 1249.25,
    y2: 53.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_568_226",
    x1: 1233.25,
    y1: 58,
    x2: 1233.25,
    y2: 77.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_568_226",
    x1: 1263.25,
    y1: 61,
    x2: 1263.25,
    y2: 80.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_568_226",
    x1: 1281.25,
    y1: 43,
    x2: 1281.25,
    y2: 62.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_568_226",
    x1: 1315.25,
    y1: 34,
    x2: 1315.25,
    y2: 53.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_568_226",
    x1: 1310.25,
    y1: 58,
    x2: 1310.25,
    y2: 77.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_568_226",
    x1: 1342.25,
    y1: 46,
    x2: 1342.25,
    y2: 65.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnownight);
export default __webpack_public_path__ + "static/media/Snow night.20a89d711249712380ea9f4269b386a3.svg";
export { ForwardRef as ReactComponent };